module.exports = __webpack_public_path__ + "static/logoMain-56566324b32f256b2db0fa7a88807c62.png";